import React from "react";
import PropTypes from "prop-types";
import { Icon } from "antd";

const DropdownList = props => {
  return (
    <div className={props.wrapClass + " form-group"}>
      {props.heading != undefined ? <label htmlFor={props.name} className="card-holder-name">
        {" "}
        {props.heading}
        {/* Phase C.7.4D-R1 (§4): see MyInput.jsx's identical fix — .ent-required-asterisk gives this
            a small explicit margin instead of relying on JSX whitespace-across-lines, which is
            stripped entirely rather than collapsed to a space. */}
        {props.isRequired && <span className="color-red ent-required-asterisk">*</span>}
      </label> : <></>}
      <select
        name={props.name}
        value={props.value}
        onChange={props.onChange}
        onKeyDown={props.onKeyDown}
        className={
          // Phase C.7.4D-R1 (§3): see MyInput.jsx's identical fix — excludes the literal tri-state
          // "success" value some callers pass into errorState, which previously read as truthy here
          // just like a real error, painting a validly-selected dropdown with the has-error border.
          "form-control " + (props.errorState && props.errorState !== "success" ? "has-error" : "")
        }
        disabled={props.isDisabled}
      >
        <option value="">{props.placeholder}</option>
        {props.options && props.options.map(option => {
          return (
            <option key={option.Id} value={option.Id} label={option.Name}>
              {option.Name}
            </option>
          );
        })}
      </select>
      {/* Stage 3.6 (Enterprise Shared Component Stabilization): error label now matches
          MyInput.jsx/TextArea.jsx's convention (d-block + close-circle Icon) — previously this was
          the only shared form control missing both, an inconsistent validation-message presentation. */}
      {props.errorState && props.errorState !== "success" && (
        <label className="color-red d-block"><Icon type="close-circle" className="mr-1" />{props.errorMessage}</label>
      )}
    </div>
  );
};

DropdownList.propTypes = {
  // Console-warning fix: every real caller across the codebase passes a bilingual JSX element (English +
  // Marathi div pair), not a plain string — the declaration below was simply out of date with actual,
  // long-standing usage. No caller or rendering behavior changes; `heading` is only ever rendered as-is
  // (see render() above), so a node has always worked, the PropTypes contract just never said so.
  heading: PropTypes.node,
  name: PropTypes.string.isRequired,
  options: PropTypes.array.isRequired,
  value: PropTypes.any.isRequired,
  placeholder: PropTypes.string.isRequired,
  errorState: PropTypes.string,
  isRequired: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  errorMessage: PropTypes.string,
  wrapClass: PropTypes.string,
  isDisabled: PropTypes.bool
};

export default DropdownList;
